import { createMuiTheme } from '@material-ui/core'

export const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 480,
      md: 768,
      lg: 1024,
      xl: 1440
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  }
})